import type { FC } from "react";
import {
    FixErrorsIcon,
    RetroIcon,
    ShortenIcon,
    SimplifyIcon,
    SummaryIcon,
} from "@/icons/ai-actions";
import type { CreateSubMenuActions, EditSubMenuActions } from "../types";

type CreateItem = {
    titleKey: string;
    action: CreateSubMenuActions;
    icon: FC;
};

type EditItem = {
    titleKey: string;
    action: EditSubMenuActions;
    icon: FC;
};

export const CREATE_AI_ACTIONS: CreateItem[] = [
    {
        titleKey: "aiActions.retro",
        action: "retro_summary",
        icon: RetroIcon,
    },
    {
        titleKey: "aiActions.shortSummary",
        action: "short_summary",
        icon: SummaryIcon,
    },
];

export const EDIT_AI_ACTIONS: EditItem[] = [
    {
        titleKey: "aiActions.fixErrors",
        action: "fix_errors",
        icon: FixErrorsIcon,
    },
    {
        titleKey: "aiActions.shorten",
        action: "shorten",
        icon: ShortenIcon,
    },
    {
        titleKey: "aiActions.simplify",
        action: "simplify",
        icon: SimplifyIcon,
    },
];
